export const AddOptions =
    [
        {
            key: "empty",
            text: "",
            value: ""
        },
        { key: "+ 0.25", text: "+ 0.25", value: "+ 0.25" },
        { key: "+ 0.50", text: "+ 0.50", value: "+ 0.50" },
        { key: "+ 0.75", text: "+ 0.75", value: "+ 0.75" },
        { key: "+ 1.00", text: "+ 1.00", value: "+ 1.00" },
        { key: "+ 1.25", text: "+ 1.25", value: "+ 1.25" },
        { key: "+ 1.50", text: "+ 1.50", value: "+ 1.50" },
        { key: "+ 1.75", text: "+ 1.75", value: "+ 1.75" },
        { key: "+ 2.00", text: "+ 2.00", value: "+ 2.00" },
        { key: "+ 2.25", text: "+ 2.25", value: "+ 2.25" },
        { key: "+ 2.50", text: "+ 2.50", value: "+ 2.50" },
        { key: "+ 2.75", text: "+ 2.75", value: "+ 2.75" },
        { key: "+ 3.00", text: "+ 3.00", value: "+ 3.00" },
        { key: "+ 3.25", text: "+ 3.25", value: "+ 3.25" },
        { key: "+ 3.50", text: "+ 3.50", value: "+ 3.50" },
        { key: "+ 3.75", text: "+ 3.75", value: "+ 3.75" },
        { key: "+ 4.00", text: "+ 4.00", value: "+ 4.00" },
        { key: "+ 4.25", text: "+ 4.25", value: "+ 4.25" },
        { key: "+ 4.50", text: "+ 4.50", value: "+ 4.50" },
        { key: "+ 4.75", text: "+ 4.75", value: "+ 4.75" },
        { key: "+ 5.00", text: "+ 5.00", value: "+ 5.00" },
        { key: "+ 5.25", text: "+ 5.25", value: "+ 5.25" },
        { key: "+ 5.50", text: "+ 5.50", value: "+ 5.50" },
        { key: "+ 5.75", text: "+ 5.75", value: "+ 5.75" },
        { key: "+ 6.00", text: "+ 6.00", value: "+ 6.00" },
        { key: "+ 6.25", text: "+ 6.25", value: "+ 6.25" },
        { key: "+ 6.50", text: "+ 6.50", value: "+ 6.50" },
        { key: "+ 6.75", text: "+ 6.75", value: "+ 6.75" },
        { key: "+ 7.00", text: "+ 7.00", value: "+ 7.00" },
        { key: "+ 7.25", text: "+ 7.25", value: "+ 7.25" },
        { key: "+ 7.50", text: "+ 7.50", value: "+ 7.50" },
        { key: "+ 7.75", text: "+ 7.75", value: "+ 7.75" },
        { key: "+ 8.00", text: "+ 8.00", value: "+ 8.00" },
        { key: "+ 8.25", text: "+ 8.25", value: "+ 8.25" },
        { key: "+ 8.50", text: "+ 8.50", value: "+ 8.50" },
        { key: "+ 8.75", text: "+ 8.75", value: "+ 8.75" },
        { key: "+ 9.00", text: "+ 9.00", value: "+ 9.00" },
        { key: "+ 9.25", text: "+ 9.25", value: "+ 9.25" },
        { key: "+ 9.50", text: "+ 9.50", value: "+ 9.50" },
        { key: "+ 9.75", text: "+ 9.75", value: "+ 9.75" },
        { key: "+ 10.00", text: "+ 10.00", value: "+ 10.00" },
        { key: "+ 10.25", text: "+ 10.25", value: "+ 10.25" },
        { key: "+ 10.50", text: "+ 10.50", value: "+ 10.50" },
        { key: "+ 10.75", text: "+ 10.75", value: "+ 10.75" },
        { key: "+ 11.00", text: "+ 11.00", value: "+ 11.00" },
        { key: "+ 11.25", text: "+ 11.25", value: "+ 11.25" },
        { key: "+ 11.50", text: "+ 11.50", value: "+ 11.50" },
        { key: "+ 11.75", text: "+ 11.75", value: "+ 11.75" },
        { key: "+ 12.00", text: "+ 12.00", value: "+ 12.00" },
        { key: "+ 12.25", text: "+ 12.25", value: "+ 12.25" },
        { key: "+ 12.50", text: "+ 12.50", value: "+ 12.50" },
        { key: "+ 12.75", text: "+ 12.75", value: "+ 12.75" },
        { key: "+ 13.00", text: "+ 13.00", value: "+ 13.00" },
        { key: "+ 13.25", text: "+ 13.25", value: "+ 13.25" },
        { key: "+ 13.50", text: "+ 13.50", value: "+ 13.50" },
        { key: "+ 13.75", text: "+ 13.75", value: "+ 13.75" },
        { key: "+ 14.00", text: "+ 14.00", value: "+ 14.00" },
        { key: "+ 14.25", text: "+ 14.25", value: "+ 14.25" },
        { key: "+ 14.50", text: "+ 14.50", value: "+ 14.50" },
        { key: "+ 14.75", text: "+ 14.75", value: "+ 14.75" },
        { key: "+ 15.00", text: "+ 15.00", value: "+ 15.00" },
        { key: "+ 15.25", text: "+ 15.25", value: "+ 15.25" },
        { key: "+ 15.50", text: "+ 15.50", value: "+ 15.50" },
        { key: "+ 15.75", text: "+ 15.75", value: "+ 15.75" },
        { key: "+ 16.00", text: "+ 16.00", value: "+ 16.00" },
        { key: "+ 16.25", text: "+ 16.25", value: "+ 16.25" },
        { key: "+ 16.50", text: "+ 16.50", value: "+ 16.50" },
        { key: "+ 16.75", text: "+ 16.75", value: "+ 16.75" },
        { key: "+ 17.00", text: "+ 17.00", value: "+ 17.00" },
        { key: "+ 17.25", text: "+ 17.25", value: "+ 17.25" },
        { key: "+ 17.50", text: "+ 17.50", value: "+ 17.50" },
        { key: "+ 17.75", text: "+ 17.75", value: "+ 17.75" },
        { key: "+ 18.00", text: "+ 18.00", value: "+ 18.00" },
        { key: "+ 18.25", text: "+ 18.25", value: "+ 18.25" },
        { key: "+ 18.50", text: "+ 18.50", value: "+ 18.50" },
        { key: "+ 18.75", text: "+ 18.75", value: "+ 18.75" },
        { key: "+ 19.00", text: "+ 19.00", value: "+ 19.00" },
        { key: "+ 19.25", text: "+ 19.25", value: "+ 19.25" },
        { key: "+ 19.50", text: "+ 19.50", value: "+ 19.50" },
        { key: "+ 19.75", text: "+ 19.75", value: "+ 19.75" },
        { key: "+ 20.00", text: "+ 20.00", value: "+ 20.00" },
        { key: "+ 20.25", text: "+ 20.25", value: "+ 20.25" },
        { key: "+ 20.50", text: "+ 20.50", value: "+ 20.50" },
        { key: "+ 20.75", text: "+ 20.75", value: "+ 20.75" },
        { key: "+ 21.00", text: "+ 21.00", value: "+ 21.00" },
        { key: "+ 21.25", text: "+ 21.25", value: "+ 21.25" },
        { key: "+ 21.50", text: "+ 21.50", value: "+ 21.50" },
        { key: "+ 21.75", text: "+ 21.75", value: "+ 21.75" },
        { key: "+ 22.00", text: "+ 22.00", value: "+ 22.00" },
        { key: "+ 22.25", text: "+ 22.25", value: "+ 22.25" },
        { key: "+ 22.50", text: "+ 22.50", value: "+ 22.50" },
        { key: "+ 22.75", text: "+ 22.75", value: "+ 22.75" },
        { key: "+ 23.00", text: "+ 23.00", value: "+ 23.00" },
        { key: "+ 23.25", text: "+ 23.25", value: "+ 23.25" },
        { key: "+ 23.50", text: "+ 23.50", value: "+ 23.50" },
        { key: "+ 23.75", text: "+ 23.75", value: "+ 23.75" },
        { key: "+ 24.00", text: "+ 24.00", value: "+ 24.00" },
        { key: "+ 24.25", text: "+ 24.25", value: "+ 24.25" },
        { key: "+ 24.50", text: "+ 24.50", value: "+ 24.50" },
        { key: "+ 24.75", text: "+ 24.75", value: "+ 24.75" },
        { key: "+ 25.00", text: "+ 25.00", value: "+ 25.00" },
        { key: "+ 25.25", text: "+ 25.25", value: "+ 25.25" },
        { key: "+ 25.50", text: "+ 25.50", value: "+ 25.50" },
        { key: "+ 25.75", text: "+ 25.75", value: "+ 25.75" },
        { key: "+ 26.00", text: "+ 26.00", value: "+ 26.00" },
        { key: "+ 26.25", text: "+ 26.25", value: "+ 26.25" },
        { key: "+ 26.50", text: "+ 26.50", value: "+ 26.50" },
        { key: "+ 26.75", text: "+ 26.75", value: "+ 26.75" },
        { key: "+ 27.00", text: "+ 27.00", value: "+ 27.00" },
        { key: "+ 27.25", text: "+ 27.25", value: "+ 27.25" },
        { key: "+ 27.50", text: "+ 27.50", value: "+ 27.50" },
        { key: "+ 27.75", text: "+ 27.75", value: "+ 27.75" },
        { key: "+ 28.00", text: "+ 28.00", value: "+ 28.00" },
        { key: "+ 28.25", text: "+ 28.25", value: "+ 28.25" },
        { key: "+ 28.50", text: "+ 28.50", value: "+ 28.50" },
        { key: "+ 28.75", text: "+ 28.75", value: "+ 28.75" },
        { key: "+ 29.00", text: "+ 29.00", value: "+ 29.00" },
        { key: "+ 29.25", text: "+ 29.25", value: "+ 29.25" },
        { key: "+ 29.50", text: "+ 29.50", value: "+ 29.50" },
        { key: "+ 29.75", text: "+ 29.75", value: "+ 29.75" },
        { key: "+ 30.00", text: "+ 30.00", value: "+ 30.00" }
    ]